/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useMemo, useState } from "react"
import { DIALOG_SIZE, HasId, ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ScalableDialog } from "src/libs/useful"
import { __, CSSObjectToString, getCssDemention } from "src/libs/utilities"
import { defaultPosition, ICurrentEditType, ILandingPrimitive, ILandingSection, IScreenPosition, LANDING_TYPE_CONTENT, ModalContent, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { IPrimitiveProps } from "../section/Primitive"
import DataContentPrimitive from "./DataContentPrimitive"
import { Intent, Position, Tooltip } from "@blueprintjs/core"



/* Protopia Ecosystem component */
export interface IModalPrimitiveProps extends IPrimitiveProps {
   
}
const ModalPrimitive = (props: IModalPrimitiveProps): JSX.Element => { 
    const isEdit: boolean   = useLandingStore((state: ILandingStore) => state.isEdit)
    const modalsOpen: ID[]  = useLandingConsoleStore((state: ILandingConsoleStore) => state.modalsOpen )
    const modals: ID[]      = useLandingConsoleStore((state: ILandingConsoleStore) => state.modals )
    const primitive: ModalContent = (props.primitive || {}) as ModalContent 
    const { id, size, title, section, type, dialogCSS, contentCSS, dialogTitleCSS, portalCSS, footerCSS } = primitive 
    const position: IScreenPosition = { ...defaultPosition(), ...primitive.position }
    const [isOpen, setIsOpen] = useState<boolean>( false )

    useEffect( () => {
        addCSSClass(
            `landing-modal-${primitive.id}`,
            `
            .landing-modal-portal-${primitive.id} {
                .bp5-overlay-backdrop {
                    ${ CSSObjectToString( portalCSS  || {} ) }
                }
            } 
            .landing-modal-${primitive.id} {
                position: absolute;
                ${ position.width ? `width:${ getCssDemention(position.width, "auto") };` : ""}
                // height:${ getCssDemention(position.height, "auto") };
                // top:${getCssDemention(position.top, "unset")};
                // left:${getCssDemention(position.left, "unset")};
                transform: rotate(${ position.rotate || 0 }deg);
                ${ CSSObjectToString( dialogCSS  || {} ) }
                .bp5-dialog-header {
                    ${ CSSObjectToString( dialogTitleCSS  || {} ) }
                    .landing-modal-title {
                        ${ 
                            !!dialogTitleCSS 
                            ?
                            `
                            color: ${dialogTitleCSS.color};
                            font-size: ${( dialogTitleCSS || {} )["font-size"] };
                            letter-spacing: ${( dialogTitleCSS || {} )["letter-spacing"]};
                            text-transform: ${( dialogTitleCSS || {} )["text-transform"]};
                            text-style: ${( dialogTitleCSS || {} )["text-style"]};
                            text-align: ${( dialogTitleCSS || {} )["text-align"]};
                            `
                            :
                            ``
                        }
                    }
                    .bp5-dialog-close-button svg[data-icon="small-cross"] {
                        fill: ${ dialogCSS?.color || dialogTitleCSS?.color };
                    }
                }
                .landing-modal-content {
                    flex-grow:100;
                    ${ CSSObjectToString( contentCSS  || {} ) }   
                }
                .landing-modal-footer {
                    ${ CSSObjectToString( footerCSS  || {} ) }
                }
            }`
        )
        
        useLandingConsoleStore.setState({ 
            modals: [ ...modals.filter( _id => id !== _id ), id ], 
            modalsOpen: modalsOpen.filter( _id => id !== _id ) 
        }) 
        return () => { 
            useLandingConsoleStore.setState({ 
                modals: modals.filter( _id => id !== _id ),
                modalsOpen: modalsOpen.filter( _id => id !== _id ),
            })
            removeCSSClass(`landing-modal-${primitive.id}`)
        }
    }, [] )

    useEffect(() => {
        setIsOpen( !!modalsOpen.filter(_id => id === _id ).length )    
    }, [modalsOpen])

    const onClick = () => {
        if(!isEdit) return 
        
        console.log( primitive )
        
        const meat  = section.data.find((meat: HasId) => meat.id === id)
        useLandingStore.setState({ 
            curEditModal: { 
                ...meat, 
                sectionId: section.id, 
                currentEditType: SELECT_TYPE.CONTENT 
            } as ICurrentEditType
        })
    }
    
    const dataPrimitive: ILandingPrimitive = useMemo<ILandingPrimitive>(
        () => {
            return { 
                data: primitive.content || [], 
                id: primitive.id, 
                title: "", 
                position: { },
                type: LANDING_TYPE_CONTENT.DATA_CONTENT,
                "data-primitive-type": LANDING_TYPE_CONTENT.DATA_CONTENT
            } as any
        },
        []
    )
    if(isEdit) {
        return <Tooltip
            intent={ Intent.PRIMARY }
            position={ Position.TOP_LEFT }
            compact
            content={ <div className="small letter-spacing-2">{ __( components()[ type ].title ) }</div> }
        >
            <div className="icon-square bg-light m-1 pointer user-select-none" data-select-type="ignore--" data-primitive-type={primitive["data-primitive-type"]} onClick={ onClick }>
                <img 
                    src={ components()[ LANDING_TYPE_CONTENT.MODAL ].icon }
                    height={ 14 }
                    alt=""
                />
            </div>
        </Tooltip>
    }

    const onClose = () => {
        const modals = modalsOpen.filter( _id => id !== _id )
        useLandingConsoleStore.setState({modalsOpen: modals})
    }

    const titleObjects = ( [ primitive.titleElementsCSS ] || []).map( (element, i) => {
        return <div style={ element } key={ i } />
    })
    const titleObj = <>
        <div className={`landing-modal-title`} dangerouslySetInnerHTML={{ __html: title }} />
        { titleObjects }
    </>
    const footerObjects = ( [ primitive.footerElementsCSS ] || []).map( (element, i) => {
        return <div style={ element } key={ i } />
    })
    const footerObj = <>
        <div className={`landing-modal-footer`} dangerouslySetInnerHTML={{ __html: "" }} />
        { footerObjects }
    </>
    return <ScalableDialog
        dialogSize={ size  }
        isOpen={isOpen }
        className={ `landing-modal-${primitive.id}` }
        portalClassName={ `landing-modal-portal-${primitive.id}` }
        title={ titleObj }
        footer={ footerObj }
        onClose={onClose}
    >
        <div className={` landing-modal-content `}>
            <DataContentPrimitive primitive={ dataPrimitive } />
        </div>
    </ScalableDialog>
}
export default ModalPrimitive
 
